module.exports = __webpack_public_path__ + "static/media/safe-cloud.8ba9b32c.png";